/* ==========================================================================
   kwmobile "new arrivals" badge -- the mark
   --------------------------------------------------------------------------
   Adds the corner tab to any product carrying the "new" tag, on both card
   types, and takes it away again when the tag goes.

   WHY A TAG AND NOT A DATE
   Shopify's created_at is the source of truth for what counts as new, but it
   cannot drive this on its own: smart collection rules have no date column, and
   Boost redraws the collection and search grids client-side so it never sees
   Liquid. A tag is the one hook the theme cards, the Boost grid, the smart
   collection and Boost's own filters can all read. A Shopify Flow workflow
   writes it on a schedule; nothing here computes a date.

   WHY NO LIQUID CHANGES
   Both card types already publish their tags to the DOM:
     - theme cards  ->  data-tags, handleized and comma separated
                        ("New Product" arrives as "new-product")
     - Boost cards  ->  data-product, whose JSON holds the raw tag strings
                        ("New Product" arrives verbatim)
   So the badge can be built without touching collection-product-card.liquid,
   which is 121 KB and draws every product card on the site. That file has no
   partial write, so not editing it is worth real effort.

   ONE MARK PER IMAGE
   Precedence is sold out, then reduced, then new. A discount beats novelty as a
   reason to buy and being unavailable beats both, so the badge steps aside
   rather than stacking. None of the products currently in the 90-day window is
   discounted, but that is luck rather than design and the next promotion could
   change it overnight.
   ========================================================================== */
(function () {
  'use strict';

  /* The tag, in both the forms the two card types publish it in. Change these
     two lines together, and change the Flow workflow to match. TAG_HANDLE is
     TAG run through Liquid's | handle filter: lowercased, non-alphanumerics
     collapsed to hyphens. */
  var TAG = 'New Product';
  var TAG_HANDLE = 'new-product';

  var CARD = '.collection-product-card';
  var BOOST_ITEM = '.boost-sd__product-item';
  var BOOST_WRAP = '.boost-sd__product-link-image';
  var THEME_CLASS = 'collection-product-card__badge--new';
  var BOOST_CLASS = 'kw-new-tab';

  /* The word. The store publishes two locales and the layout sets <html lang>,
     so this follows the page rather than needing a locale string -- which the
     badge could not read anyway, being built in the browser rather than in
     Liquid. Anything that is not German gets the English word. */
  function word() {
    var lang = (document.documentElement.getAttribute('lang') || 'en');
    return lang.slice(0, 2).toLowerCase() === 'de' ? 'Neu' : 'New';
  }

  function make(className) {
    var el = document.createElement('span');
    el.className = className;
    /* The badge repeats information that is already in the collection and in
       the product's own page, and a screen reader hitting it first would hear
       "new" before the product name. */
    el.setAttribute('aria-hidden', 'true');
    el.textContent = word();
    return el;
  }

  /* Add or remove, never leave a hidden element behind: an empty span inside
     the badges container would still take part in layout on the theme card. */
  function paint(parent, on, className, first) {
    if (!parent) return;
    var el = parent.querySelector('.' + className.split(' ').pop());
    if (!on) {
      if (el) el.parentNode.removeChild(el);
      return;
    }
    if (el) return;
    el = make(className);
    if (first && parent.firstChild) parent.insertBefore(el, parent.firstChild);
    else parent.appendChild(el);
  }

  /* ---- Theme product cards ----------------------------------------------- */

  /* Sold out and reduced are read from the theme's own badge elements rather
     than from data-availability, because the theme rewrites those two inline
     styles on every swatch click while the data attribute stays at whatever the
     page was rendered with. Reading them keeps this badge agreeing with the
     card instead of contradicting it. */
  function shown(el) {
    return !!el && el.style.display !== 'none';
  }

  function updateCard(card) {
    var box = card.querySelector('.collection-product-card__badges');
    if (!box) return;

    var tags = (card.getAttribute('data-tags') || '').split(',');
    var isNew = tags.indexOf(TAG_HANDLE) !== -1;

    var soldOut = shown(card.querySelector('.collection-product-card__badge--sold-out'));
    var onSale = shown(card.querySelector('.collection-product-card__badge--sale'));

    paint(box, isNew && !soldOut && !onSale,
      'collection-product-card__badge ' + THEME_CLASS, true);
  }

  /* ---- Boost cards -------------------------------------------------------- */

  function boostProduct(item) {
    try {
      return JSON.parse(item.getAttribute('data-product') || '{}');
    } catch (e) {
      return {};
    }
  }

  function updateBoostCard(item) {
    var wrap = item.querySelector(BOOST_WRAP);
    if (!wrap) return;

    var p = boostProduct(item);
    var tags = p.tags || [];
    var isNew = tags.indexOf(TAG) !== -1;

    /* Reduced is decided from the prices in the payload rather than from
       Boost's own sale label, because that label is a custom template whose
       markup we do not control. Both values arrive as strings. */
    var now = parseFloat(p.priceMin);
    var was = parseFloat(p.compareAtPriceMin);
    var onSale = isFinite(now) && isFinite(was) && was > now;

    /* Boost's card template has no sold-out state of its own, so this reads the
       attribute the out-of-stock work adds. If that ever goes away the check
       simply stops firing and a sold-out new product keeps its badge -- wrong,
       but not broken. */
    var soldOut = item.getAttribute('data-kw-oos') === '1';

    paint(wrap, isNew && !soldOut && !onSale, BOOST_CLASS, false);
  }

  /* ---- Wiring ------------------------------------------------------------- */

  function scan() {
    var cards = document.querySelectorAll(CARD);
    for (var i = 0; i < cards.length; i++) updateCard(cards[i]);

    var items = document.querySelectorAll(BOOST_ITEM);
    for (var j = 0; j < items.length; j++) updateBoostCard(items[j]);
  }

  function start() {
    scan();
    /* Sliders, Boost and lazy sections all add cards after first paint, and a
       swatch click rewrites the sold-out and sale badges in place. */
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(scan, 150);
    }).observe(document.body, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['style', 'data-tags', 'data-product', 'data-kw-oos'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* NOT DONE HERE: the product detail page. The sale flag marks the PDP image,
     but a "new" mark there would sit on a photo the customer has already chosen
     to look at, and the badge's job is to pull attention inside a grid. If it is
     wanted later it is the same shape as the PDP sale flag: one element in
     snippets/product-media-swiper.liquid and one rule keyed off the tag. */
})();
